export default __webpack_public_path__ + "static/LeituraTwo-MediumItalic-6e8f019dbcbfc03ca55f67504e7de4c1.woff2";